module.exports = __webpack_public_path__ + "static/media/file_upload_white.e54936df.svg";